import cx from 'classnames'
import styles from './LoadingPage.module.css'
import { Spinner } from '@/components/Spinner'

interface LoadingPageProps {
  /**
   * Whether this page takes up the entire viewport.
   */
  full?: boolean
}

/**
 * The LoadingPage
 */
export function LoadingPage({ full }: LoadingPageProps) {
  return (
    <div className={cx(styles.root, full && styles.full)}>
      <div className={styles.center}>
        <Spinner />
      </div>
    </div>
  )
}
